module.exports = __webpack_public_path__ + "img/address.113b293c.png";